module.exports = __webpack_public_path__ + "static/media/mv_logo_small.79bf1e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/vereine/mv_logo_small.png
// module id = 593
// module chunks = 0